module.exports = __webpack_public_path__ + "static/media/me.faf4854e.JPG";